import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Checkbox, InputDate, Textarea, TimePicker } from 'components/fields'
import { Button, ButtonGroup } from 'components/misc'

export default class ActivityLog extends Component {
  static propTypes = {
    id: PropTypes.number,
    disabled: PropTypes.bool,
    isEditing: PropTypes.bool,
    isLoading: PropTypes.bool,
    intlKey: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    onRemove: PropTypes.func,
    title: PropTypes.string,
    isDeleted: PropTypes.func,
    onRestore: PropTypes.func,
    isBulkLogs: PropTypes.bool,
    removeLogSet: PropTypes.bool
  }

  render() {
    const {
      disabled,
      title,
      intlKey,
      isDeleted,
      isEditing,
      id,
      removeLogSet,
      isLoading,
      isBulkLogs
    } = this.props
    return (
      <div>
        <h2>
          {intlKey
            ? <FormattedMessage id={intlKey} defaultMessage={title} />
            : title}
        </h2>
        <div className="row">
          <div className="col-xs-6">
            <InputDate
              disabled={disabled}
              label="Date"
              intlKey="label.date"
              name="date"
              maxToday
              logs
            />
          </div>
          <div className="col-xs-4">
            <TimePicker
              disabled={disabled}
              label="Duration (min)"
              intlKey="label.duration"
              name="duration"
              type="number"
              min={0}
              step={15}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <Textarea
              disabled={disabled}
              label="Description"
              intlKey="label.description"
              name="description"
            />
          </div>
        </div>
        <div className="row">
        <div className="col-xs-8">
          {isEditing && !isDeleted && isBulkLogs && <Checkbox
            name="removeLogSet"
            label="Remove whole log set"
            intlKey="label.remove_log_set"
          />}
        </div>
        </div>
        <div className="row">
          <div className="col-xs-6">
            <ButtonGroup>
              <Button type="button" secondary onClick={this.props.onClose}>
                <FormattedMessage id="button.close" defaultMessage="Close" />
              </Button>
              {isDeleted &&
                <Button type="button" onClick={() => this.props.onRestore(id)}>
                  <FormattedMessage
                    id="button.restore"
                    defaultMessage="Restore"
                  />
                </Button>}
                  {isEditing &&
                !isDeleted &&
                <Button
                  type="button"
                  negative
                  onClick={() => this.props.onRemove(id, removeLogSet)}
                >
                  <FormattedMessage
                    id="button.delete"
                    defaultMessage="Delete"
                  />
                </Button>}
            </ButtonGroup>
          </div>
          <div className="col-xs-6 text--right">
            <Button disabled={disabled} isLoading={isLoading}>
              <FormattedMessage id="button.save" defaultMessage="Save" />
            </Button>
          </div>
        </div>
      </div>
    )
  }
}
